import React, { ReactElement } from 'react'
import {Card, CardCategory, CardFooter, CardHeader, CardIcon, CardTitle, Icons} from "@fabricks/ui-components";

interface CardElementProps {
    data?: any
    valid?: any
    title?: any
    icon?: any
    styles?: any
    unit?: any
    onClick?: (event: any) => void
}

export const CardElement = (props: CardElementProps, config: any): ReactElement => {
    const { data, valid, title, icon, styles, unit, onClick} = props

    return (
        <Card className="card">
            <CardHeader isStats={false} hasIcon type="plain">
                <CardIcon className="cardIcon" color="primary">
                    <div onClick={onClick} style={styles}>
                        {icon}
                    </div>
                </CardIcon>
                <CardCategory title={`${title}`} />
                <CardTitle title={`${data}`} variant={"h3"} unit={unit || ""} padding={"0"}/>
            </CardHeader>
            <div onClick={onClick} style={styles}>
                <CardFooter isStats={false}>
                    {valid}
                </CardFooter>
            </div>
        </Card>
    )
}
